export default "__VITE_ASSET__cbb03866__"